//Sidewise Collapseable format
import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
// import { AppConfig } from 'src/config/AppConfig';
import TableView from '../TableView/TableView';
import AlertDetailsCard from './AlertDetails';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const NmsDashGrid = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = () => setCollapsed((prev) => !prev);

  return (
    <div className="p-1">
      <div className="mb-2">
        <Card className="mb-2">
          <CardContent
            sx={{
              padding: '0px',
              '&:last-child': { paddingBottom: '0px !important' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
                padding: 2,
              }}
            >
              {/* Left: Alert Details Section */}
              <Box
                sx={{
                  flex: collapsed ? '0 0 40px' : '0 0 250px',
                  maxWidth: collapsed ? '40px' : '250px',
                  position: 'sticky',
                  top: 0,
                  alignSelf: 'flex-start',
                  zIndex: 2,
                  transition: 'all 0.3s ease-in-out',
                  backgroundColor: 'background.paper',
                  borderRight: '1px solid #e0e0e0',
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: collapsed ? 'center' : 'flex-end',
                    padding: 1,
                  }}
                >
                  {!collapsed && (
                    <Typography variant="subtitle1" fontWeight="bold">
                     Selected Alert Details
                    </Typography>
                  )}
                  <IconButton onClick={toggleCollapse} size="small">
                    {collapsed ? <ChevronRight /> : <ChevronLeft />}
                  </IconButton>
                </Box>
   
                {!collapsed && (
                  <Box sx={{ px: 1, pb: 2 }}>
                    <AlertDetailsCard />
                  </Box>
                )}
              </Box>

              {/* Right: TableView */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <TableView />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NmsDashGrid;
